import { render, staticRenderFns } from "./ProductBackView.vue?vue&type=template&id=af9f7a50&scoped=true&"
import script from "./ProductBackView.vue?vue&type=script&lang=js&"
export * from "./ProductBackView.vue?vue&type=script&lang=js&"
import style0 from "./ProductBackView.vue?vue&type=style&index=0&id=af9f7a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9f7a50",
  null
  
)

export default component.exports